import React from "react";

interface ActlInputProps {
  handleSubmit: Function;
  setGuessedWordsInput: Function;
  guessedWordsInput: string;
}

const Inputs = ({ handleSubmit, guessedWordsInput, setGuessedWordsInput }: ActlInputProps) => {
  return (
    <div className="flex pt-2.5">
      <input
        type="text"
        className="pr-2.5 border border-gray-300 rounded px-3 py-2 mr-2 flex-1"
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleSubmit();
          }
        }}
        value={guessedWordsInput}
        onChange={(e) => setGuessedWordsInput(e.currentTarget.value)}
      />
      <button
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        onClick={() => handleSubmit()}
      >
        Submit
      </button>
    </div>
  );
};

export default Inputs;
